import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function prepararParaSalvarPesquisaPrecos(pesquisas) {
  var pesquisaPrecos = [];

  for (let pesquisa of pesquisas) {
    pesquisaPrecos.push({
      IDPesquisa: pesquisa.idPesquisa,
      IDFornecedor: pesquisa.idFornecedor,
      TipoPessoa: pesquisa.tipoPessoa,
      IDItemCompra: pesquisa.idItemCompra,
      ValorUnitario: pesquisa.valorUnitario,
      DescontoPercentual: pesquisa.descontoPercentual,
      DescontoDinheiro: pesquisa.descontoDinheiro,
      ValorFrete: pesquisa.valorFrete,
      QuantidadeCaixa: pesquisa.quantidadeCaixa,
      FormaPagamento: pesquisa.formaPagamento,
      IPIPesquisa: pesquisa.ipiPesquisa,
      Marca: pesquisa.marca,
      Modelo: pesquisa.modelo,
      ObservacaoPesquisa: pesquisa.observacaoPesquisa,
    });
  }

  return pesquisaPrecos;
}

function prepararParaSalvarPesquisaPreco(pesquisa) {
  var pesquisaPreco = {
      IDPesquisa: pesquisa.idPesquisa,
      IDFornecedor: pesquisa.idFornecedor,
      TipoPessoa: pesquisa.tipoPessoa,
      IDItemCompra: pesquisa.idItemCompra,
      ValorUnitario: pesquisa.valorUnitario,
      DescontoPercentual: pesquisa.descontoPercentual,
      DescontoDinheiro: pesquisa.descontoDinheiro,
      ValorFrete: pesquisa.valorFrete,
      QuantidadeCaixa: pesquisa.quantidadeCaixa,
      FormaPagamento: pesquisa.formaPagamento,
      IPIPesquisa: pesquisa.ipiPesquisa,
      Marca: pesquisa.marca,
      Modelo: pesquisa.modelo,
      ObservacaoPesquisa: pesquisa.observacaoPesquisa,
  };

  return pesquisaPreco;
}

export default {
  listaContrato: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/contratos/fornecedor', { params: parametros });
  },
  listaPesquisaPreco: (pagina = 1, idCompra = 0, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
        parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
        parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    parametros.idCompra = idCompra;

    return Vue.http.get('/api/pesquisapreco/fornecedor', { params: parametros });
  },
  listaSolicitacaoPesquisaPreco: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/pesquisapreco/listasolicitacaofornecedor', { params: parametros });
  },
  solicitacaoPesquisaPreco: (id) => {
    return Vue.http.get(`/api/pesquisapreco/solicitacaofornecedor/${id}`);
  },
  responderPesquisaPrecos: async (pesquisaPrecos) => {
    pesquisaPrecos = await prepararParaSalvarPesquisaPrecos(pesquisaPrecos)

    return Vue.http.put('/api/pesquisapreco/fornecedor', pesquisaPrecos)
      .then(resposta => resposta.body);
  },
  responderPesquisaPreco: async (pesquisaPreco) => {
    pesquisaPreco = await prepararParaSalvarPesquisaPreco(pesquisaPreco)

    return Vue.http.put('/api/pesquisapreco/fornecedoritem', pesquisaPreco)
      .then(resposta => resposta.body);
  },
  alterarSolicitacaoPesquisaPreco: (id, arquivos, arquivosDeletados) => {
    let pesquisaPreco = {
      arquivos: arquivos,
      arquivosDeletados: arquivosDeletados
    }

    pesquisaPreco = converterObjetoFormData(pesquisaPreco);

    return Vue.http.put(`/api/pesquisapreco/solicitacaofornecedor/${id}`, pesquisaPreco)
      .then(resposta => resposta.body);
  },
  arquivos: id => {
    return Vue.http.get(`/api/contratos/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
      return Vue.http.get(`/api/contratos/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
          return salvarArquivo(response, arquivo);
      });
  },
  arquivosSolicitacaoPesquisaPreco: (id) => {
    return Vue.http.get(`/api/pesquisapreco/solicitacaofornecedor/${id}/arquivos`)
      .then(response => response.data);
  },
  downloadSolicitacaoPesquisaPreco: (id, arquivo) => {
    return Vue.http.get(`/api/pesquisapreco/solicitacaofornecedor/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/fornecedor/servico.js